import type { Schemas } from "#shopware";
import { useCartFunction as swUseCart } from "@shopware/composables";

const _useCart = (): UseCartReturn & {
  taxRate: ComputedRef<number>;
  totalNet: ComputedRef<number>;
  clearCart: () => Promise<void>;
} => {
  const useCartData: UseCartReturn = swUseCart();

  const { apiClient } = useShopwareContext();
  /**
   * Example on how to override the default `refreshCart` method
   *
   * @param {Schemas["Cart"]} newCart
   * @returns
   */
  async function refreshCart(
    newCart?: Schemas["Cart"]
  ): Promise<Schemas["Cart"]> {
    return useCartData.refreshCart(newCart);
  }

  const taxRate = computed(() => {
    const taxRules = useCartData.cart.value?.price?.taxRules;

    if (!taxRules) {
      return 0;
    }

    return taxRules[0]?.taxRate || 0;
  });

  const totalNet = computed(() => {
    return useCartData.cart.value?.price?.netPrice || 0;
  });


    /**
   * Clear all items from the cart
   */
    async function clearCart(): Promise<void> {
      try {
        await apiClient.invoke("deleteCart delete /checkout/cart");
        // Refresh cart after clearing to update the UI
        await refreshCart();
      } catch (error) {
        console.error("[useCart] Failed to clear cart:", error);
        throw error;
      }
    }

  return {
    ...useCartData,
    refreshCart,
    taxRate,
    totalNet,
    clearCart,
  };
};

export const useCart = createSharedComposable(_useCart);
